import React, { useState } from "react";
import axiosInstance from "../utils/axiosInstance";

export default function DailyPlByGameTypeTest() {
  const [gameType, setGameType] = useState("");
  const [marketType, setMarketType] = useState("");
  const [gameName, setGameName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [response, setResponse] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    const payload = {};
    if (gameType) payload.game_type = gameType;
    if (marketType) payload.market_type = Number(marketType);
    if (gameName.trim()) payload.game_name = gameName.trim();

    try {
      const res = await axiosInstance.post(
        "/master/daily-pl-by-game-type",
        payload
      );
      setResponse(res.data);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data?.errors?.game_type ||
          err.message ||
          "Request failed"
      );
      setResponse(err.response?.data || null);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <h1>Daily P/L by Game Type Test</h1>
      <p>POST /master/daily-pl-by-game-type</p>

      <form onSubmit={handleSubmit}>
        <div>
          <label>
            game_type:{" "}
            <input
              value={gameType}
              onChange={(e) => setGameType(e.target.value)}
              placeholder="e.g. cricket or 1"
            />
          </label>
        </div>
        <div>
          <label>
            market_type:{" "}
            <input
              value={marketType}
              onChange={(e) => setMarketType(e.target.value)}
              placeholder="optional"
            />
          </label>
        </div>
        <div>
          <label>
            game_name:{" "}
            <input
              value={gameName}
              onChange={(e) => setGameName(e.target.value)}
              placeholder="optional"
            />
          </label>
        </div>
        <button type="submit" disabled={loading}>
          {loading ? "Loading..." : "Search"}
        </button>
      </form>

      {error ? <p>{error}</p> : null}

      <h2>Response</h2>
      <pre>{JSON.stringify(response, null, 2)}</pre>
    </div>
  );
}
